import { useParams } from "react-router-dom";
import TranscriptInfographicComponent from '../components/infographic/transcript/transcript-infographic.component';

const TranscriptInfographic = () => {
    const { mediaId, infoId } = useParams();

    return (
        <TranscriptInfographicComponent mediaId={mediaId} infoId={infoId} />
    )

}

export default TranscriptInfographic;